import { render, staticRenderFns } from "./Explainer.vue?vue&type=template&id=2ca4d436&scoped=true"
import script from "./Explainer.vue?vue&type=script&lang=js"
export * from "./Explainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca4d436",
  null
  
)

export default component.exports